var _rect, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveUsers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "active_users",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1443",
    "data-name": "Rectangle 1443",
    width: 38,
    height: 38,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Player",
    transform: "translate(0 10.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_808",
    "data-name": "Group 808",
    transform: "translate(0.927 15.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4400",
    "data-name": "Path 4400",
    d: "M52.122,266.809H30.3c0-7.572,5.872-9.241,10.91-9.241S52.122,259.237,52.122,266.809Z",
    transform: "translate(-30.302 -257.568)",
    fill: "#65b0f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_809",
    "data-name": "Group 809",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4401",
    "data-name": "Path 4401",
    d: "M37.376,252.989H15.556a.911.911,0,0,1-.927-.927c0-6.552,4.2-10.168,11.837-10.168S38.3,245.51,38.3,252.062A.911.911,0,0,1,37.376,252.989Zm-20.862-1.854h19.9c-.371-4.914-3.709-7.387-9.952-7.387S16.885,246.221,16.514,251.135Z",
    transform: "translate(-14.629 -227.584)",
    fill: "#3c4043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4402",
    "data-name": "Path 4402",
    d: "M116.91,12.95a6.433,6.433,0,0,1-6.15-6.676,6.152,6.152,0,1,1,12.3,0A6.433,6.433,0,0,1,116.91,12.95Zm0-11.1a4.206,4.206,0,0,0-4.3,4.42,4.325,4.325,0,1,0,8.592,0A4.259,4.259,0,0,0,116.91,1.854Z",
    transform: "translate(-105.073)",
    fill: "#3c4043"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "X",
    transform: "translate(1.764 7.683) rotate(30)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y2: 2.895,
    transform: "matrix(0.545, 0.839, -0.839, 0.545, 2.428, 0.425)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x1: 2.895,
    transform: "matrix(0.545, 0.839, -0.839, 0.545, 0.426, 0)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Circle",
    transform: "translate(14.302 5.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4383",
    "data-name": "Path 4383",
    d: "M168.041,54.1a1.185,1.185,0,1,1-1.185-1.185A1.185,1.185,0,0,1,168.041,54.1Z",
    transform: "translate(-165.671 -52.912)",
    fill: "#fee96b"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Circle-2",
    "data-name": "Circle",
    transform: "translate(0.622 16.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4385",
    "data-name": "Path 4385",
    d: "M168.041,54.1a1.185,1.185,0,1,1-1.185-1.185A1.185,1.185,0,0,1,168.041,54.1Z",
    transform: "translate(-165.671 -52.912)",
    fill: "#abda7c"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Polygon",
    transform: "translate(29.235 26.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4384",
    "data-name": "Path 4384",
    d: "M176.238,72.532l2.1-3.641,2.1,3.641Z",
    transform: "translate(-176.238 -68.891)",
    fill: "none",
    stroke: "#5fb4f6",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "hourglass-2",
    transform: "translate(24.32 1.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_807",
    "data-name": "Group 807",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_806",
    "data-name": "Group 806"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4396",
    "data-name": "Path 4396",
    d: "M157.2,329.895l-.019.021a.678.678,0,0,0,.483,1.136h6.333a.678.678,0,0,0,.483-1.136l-.019-.021c-.588-.646-2.8-2.566-2.83-2.591a1.2,1.2,0,0,0-1.6,0C160,327.329,157.785,329.249,157.2,329.895Z",
    transform: "translate(-155.166 -318.271)",
    fill: "#ffbb39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4397",
    "data-name": "Path 4397",
    d: "M68.792,6.873c.136-.118.292-.249.456-.387,1.215-1.021,2.878-2.419,2.878-3.889V1.712A1.714,1.714,0,0,0,70.415,0h-7.7A1.714,1.714,0,0,0,61,1.712V2.6c0,1.47,1.663,2.868,2.878,3.889.165.138.32.269.456.387a.558.558,0,0,1,0,.861c-.136.118-.292.249-.456.387C62.663,9.143,61,10.541,61,12.011V12.9a1.714,1.714,0,0,0,1.712,1.712h7.7A1.714,1.714,0,0,0,72.126,12.9a.571.571,0,1,0-1.141,0,.571.571,0,0,1-.571.571h-7.7a.571.571,0,0,1-.571-.571v-.884c0-.938,1.547-2.239,2.471-3.016.168-.142.328-.275.471-.4a1.7,1.7,0,0,0,0-2.583c-.143-.125-.3-.258-.471-.4-.924-.777-2.471-2.077-2.471-3.016V1.712a.571.571,0,0,1,.571-.571h7.7a.571.571,0,0,1,.571.571V2.6c0,.938-1.547,2.239-2.471,3.016-.168.142-.328.275-.471.4a1.7,1.7,0,0,0,0,2.583c.149.13.316.269.492.417a15.881,15.881,0,0,1,1.681,1.552.571.571,0,1,0,.854-.757,17.005,17.005,0,0,0-1.8-1.67c-.172-.144-.334-.28-.475-.4a.558.558,0,0,1,0-.861Z",
    transform: "translate(-61 0)",
    fill: "#3c4043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4398",
    "data-name": "Path 4398",
    d: "M203.435,129.578c.016-.014.634-.545,1.338-1.167a.806.806,0,0,0-.519-1.41h-3.461a.806.806,0,0,0-.519,1.41c.7.623,1.322,1.153,1.338,1.167A1.383,1.383,0,0,0,203.435,129.578Z",
    transform: "translate(-196.931 -124.656)",
    fill: "#ffbb39"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveUsers);
export default __webpack_public_path__ + "static/media/active_users.7dc712713cc6848da025d11ff92c2b6f.svg";
export { ForwardRef as ReactComponent };